export default "__VITE_ASSET__CkW$alvK__"